const details = {
    name: "سالی تویز",
    enName: "shop",
    description: "فروش و پخش انواع اسباب بازی خارجی و ایرانی",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "شرکت توسعه و طراحی سایت باران",
        link: "https://barantm.com"
    },
    meta:{
        title: "فروشگاه سالی تویز، فروش و پخش اینترنتی انواع اسباب بازی خارجی و ایرانی",
        description : 'فروشگاه سالی تویز، فروش و پخش اینترنتی انواع اسباب بازی خارجی و ایرانی',
        locale : 'fa-IR',
    }
}

export default details;
